import { type ApiClient } from './api-client.js';

/** Module apps a user can be handed off to via cross-module SSO (A8). */
export type SwitchableModule = 'pilot' | 'progress' | 'insight' | 'admin';

/**
 * Requests a single-use cross-module SSO handoff code from /auth/sso/exchange.
 * Call with the authenticated ApiClient of the source (current) app.
 */
export async function requestSsoExchangeCode(
  api: ApiClient,
  targetModule: SwitchableModule,
): Promise<string> {
  const res = await api.post<{ code: string; expiresIn: number }>('/auth/sso/exchange', {
    targetModule,
  });
  const code = res.data?.code;
  if (!code) throw new Error('SSO exchange did not return a code');
  return code;
}

/**
 * Builds the target app's `/sso` landing URL carrying the handoff code. The
 * target app redeems it via /auth/sso/redeem to establish its own session.
 */
export function buildSsoRedirectUrl(appBaseUrl: string, code: string): string {
  const url = new URL('/sso', appBaseUrl);
  url.searchParams.set('code', code);
  return url.toString();
}
